import React from 'react'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { Checkbox, Paragraph, Surface, useTheme } from 'react-native-paper'

const CheckCard = ({
  title,
  subtitle,
  checked,
  onPress,
  onLongPress = null,
}) => {
  const { colors } = useTheme()

  return (
    <TouchableOpacity onPress={onPress} onLongPress={onLongPress}>
      <Surface elevation={2} style={[styles.container]}>
        <View style={{ padding: 5 }}>
          <Paragraph style={{ fontWeight: 'bold' }}>{title}</Paragraph>
          {subtitle && <Paragraph>{subtitle}</Paragraph>}
        </View>
        <Checkbox
          status={checked ? 'checked' : 'unchecked'}
          color={colors.primary}
        />
      </Surface>
    </TouchableOpacity>
  )
}
const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 5,
    paddingLeft: 10,
    borderRadius: 10,
    marginVertical: 2,
  },
})

export default CheckCard
